
import React from 'react'
import Menu from './Menu'
import Box from './Box'

/**
 * Nav component.
 */

export default Nav

/**
 * Expose components.
 */

Nav.Item = Menu.Item

/**
 * Nav component.
 */

function Nav({ children }) {
  return <Box className="Nav">
    <Menu>
      {children}
    </Menu>
  </Box>
}
